import { css, keyframes } from 'styled-components'

const duration = 1.8

const loadingAnimation = keyframes`
  0% {
    transform: translate3d(-30%, 0, 0);
  }
  
  100% {
    transform: translate3d(30%, 0, 0);
  }
`

export const animatedLoadingEffect = css`
  position: relative;
  overflow: hidden;
  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 50%;
    z-index: 1;
    width: 500%;
    margin-left: -250%;
    animation: ${loadingAnimation} ${duration}s ease-in-out infinite;
    background: linear-gradient(
        to right,
        transparent 46%,
        rgba(255, 255, 255, 0.35) 50%,
        transparent 54%
      )
      50% 50%;
  }
`
